import { render, staticRenderFns } from "./sloganIconBlock.vue?vue&type=template&id=6545367d&scoped=true&"
import script from "./sloganIconBlock.vue?vue&type=script&lang=js&"
export * from "./sloganIconBlock.vue?vue&type=script&lang=js&"
import style0 from "./sloganIconBlock.vue?vue&type=style&index=0&id=6545367d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6545367d",
  null
  
)

export default component.exports